import { useMemo } from 'react'

import { Input } from '@circlefin/components/lib/Input'

import type { BlockchainAbbreviation } from '@shared/graphql'

export interface FormattedWalletAddressProps {
  /**
   * Heading.
   */
  heading?: string
  /**
   * Wallet Address.
   */
  address?: string
  /**
   * Blockchain Name.
   */
  chain: BlockchainAbbreviation
  /**
   * Wallet Name.
   */
  walletName?: string
}

export const FormattedWalletAddress: React.FC<FormattedWalletAddressProps> = ({
  heading,
  address,
  chain: chainName,
  walletName,
}) => {
  const formattedAddress = useMemo(() => {
    if (!address) {
      return ''
    }

    const start = address.substring(0, 2)
    const end = address.substring(address.length - 6)
    return `${start}*****${end}`
  }, [address])

  return (
    <>
      {heading && <h3 className="type-h-title-md">{heading}</h3>}

      <Input className="mb-4" readOnly>
        <Input.Field.Custom>
          <Input.Inline.Icon align="left" name={chainName} />
          {walletName}
          <div className="ml-auto">{formattedAddress}</div>
        </Input.Field.Custom>
      </Input>
    </>
  )
}
